import type { ReactNode } from "react";

import {
  ALL_PERMISSIONS,
  PermissionContext,
  type PermissionSet,
} from "@/auth/permissions";

/**
 * Supplies the permission set the shell filters navigation with.
 *
 * `permissions` is a prop rather than something this fetches, so M15-5 hands
 * it `CurrentUser.permissions` without touching anything below it — and so a
 * restricted user can be rendered in a test by passing a smaller set.
 */
export function PermissionProvider({
  permissions = ALL_PERMISSIONS,
  children,
}: {
  permissions?: PermissionSet;
  children: ReactNode;
}) {
  return <PermissionContext value={permissions}>{children}</PermissionContext>;
}
